import { useEffect } from "react";
import PropertyInput from "../components/inputs/input-property.tsx";
import {H, ViewCopy, ViewDialog} from "../components/view.tsx";
import { useStore } from "../state/state.ts";
import { InputVerbrauch, InputVerbrauchsEinheit } from "../components/inputs/input_verbrauch.tsx";

export default function ViewBase3() {
   return (<ViewDialog ><ViewBase3Inner/></ViewDialog>)
}

export function ViewBase3Inner() {
   //const heizung = useStore((state)=>state.heizung);
   // const api_basic_data = useStore((state)=>state.api_basic_data);

   // useEffect(()=>{
   //    api_basic_data();
   // },[heizung]);

   // const verbrauch = ()=>{
   //    switch (heizung) {
   //       case "heating_system_current_0":
   //       case "heating_system_current_8":
   //          return <PropertyInput placeholder_prefix="z.B." type="oelverbrauch"/>
   //       case "heating_system_current_1":
   //       case "heating_system_current_7":
   //          return <PropertyInput placeholder_prefix="z.B." type="gasverbrauch"/>
   //       case "heating_system_current_2":
   //          return <PropertyInput placeholder_prefix="z.B." type="holzverbrauch"/>
   //       case "heating_system_current_3":
   //          return <PropertyInput placeholder_prefix="z.B." type="stromverbrauchwaermepumpe"/>
   //       case "heating_system_current_4":
   //          return <PropertyInput placeholder_prefix="z.B." type="stromverbrauchwaermepumpe"/>
   //       case "heating_system_current_6":
   //          return <PropertyInput placeholder_prefix="z.B." type="gasverbrauch" label_override={"Fernwärmeverbrauch"}/>
   //       default:
   //          return <></>
   //    }
   // }

   return (<>
            <ViewCopy><H>Die Informationen zur Heizung als Basis der Berechnungen festlegen.</H></ViewCopy>
            <PropertyInput placeholder_prefix="z.B." type="heizung"/>
            <InputVerbrauchsEinheit />
            <InputVerbrauch />
            <p className="input_hint" style={{
               color: "gray",
            }}>Liegt der tatsächliche Verbrauch vor, kann dieser hier eingetragen und zur weiteren Berechnung genutzt werden. In diesem Fall bleibt dieser Verbrauch auch bei Eingabe bereits durchgeführter Sanierungen unverändert.</p>
            {/* <PropertyInput placeholder_prefix="z.B." type="stromverbrauch"/> */}
         </>)
}